// Režim behu portálu: web, Cordova aplikácia alebo nainštalovaná PWA.
// Cordova ostáva podporovaná súbežne s PWA; „správanie aplikácie“ (dlhé prihlásenie, úvodné
// skenovanie QR, ikony) sa riadi isApp()/showAppHome(), nie priamo window.cordova.

export function isCordova() {
    return !!window.cordova;
}

// spustená z plochy ako nainštalovaná PWA (Android/desktop: display-mode, iOS: navigator.standalone)
export function isStandalone() {
    try {
        if (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) {
            return true;
        }
    } catch (e) {
        // starší prehliadač bez matchMedia
    }
    return window.navigator.standalone === true;
}

export function isApp() {
    return isCordova() || isStandalone();
}

// nezhodná cesta (napr. koreň) zobrazí úvodnú obrazovku so skenovaním QR inštancie – len v Cordove.
// Web/PWA sa inštaluje priamo z adresy portálu mandanta (applyAppManifest), QR netreba.
export function showAppHome() {
    return isCordova();
}

function isDevelopment() {
    return !process.env.NODE_ENV || process.env.NODE_ENV === "development";
}

// základná adresa servletov inštancie
// - dev: /offeris/ (CRA proxy na localhost:8080)
// - voliteľne REACT_APP_API_PROXY + instance (len lokálny test buildu proti Tomcatu bez CORS)
// - inak priamo https://<instance>.offeris.com/<instance>/ (produkcia posiela CORS *)
export function getEndpoint(instance) {
    if (isDevelopment()) {
        return "/offeris/";
    }
    let proxy = process.env.REACT_APP_API_PROXY;
    if (proxy) {
        if (!proxy.endsWith("/")) {
            proxy += "/";
        }
        return proxy + instance + "/";
    }
    return "https://" + instance + ".offeris.com/" + instance + "/";
}

// krátky názov appky pod ikonou: časť za "|" z portal_name, max 15 znakov (rovnako ako public/manifest.php)
export function getAppShortName(portalName) {
    let name = String(portalName || "").trim();
    let pos = name.lastIndexOf("|");
    if (pos >= 0) {
        name = name.substring(pos + 1).trim();
    }
    // bez právnej formy na konci ("G.P.R. spol. s r.o." -> "G.P.R.")
    let withoutLegal = name.replace(/[,\s]*(spol\.\s*s\s*r\.\s*o\.|s\.\s*r\.\s*o\.|a\.\s*s\.|k\.\s*s\.|v\.\s*o\.\s*s\.)\s*$/i, "").trim();
    if (withoutLegal) {
        name = withoutLegal;
    }
    if (name.length > 15) {
        // rez na hranici slova ("G.P.R. spol. s r.o." -> "G.P.R. spol.")
        let cut = name.substring(0, 16);
        let space = cut.lastIndexOf(" ");
        name = (space > 0 ? cut.substring(0, space) : name.substring(0, 15)).trim();
    }
    return name || "Offeris";
}

function setHeadElement(selector, create, attribute, value) {
    let element = document.head.querySelector(selector);
    if (!element) {
        element = create();
        document.head.appendChild(element);
    }
    if (element.getAttribute(attribute) !== value) {
        element.setAttribute(attribute, value);
    }
}

// Portál mandanta sa dá nainštalovať z prehliadača ako samostatná appka: manifest na
// <basename>/manifest.json generuje public/manifest.php (vlastné id, start_url, scope a názov),
// ikony z loga mandanta public/icon.php (aj apple-touch-icon pre iPhone, ktorý manifest nečíta).
// Volá sa v B2B portáli a na prihlasovacej stránke; koreň a B2C odkazy na doklad manifest nemajú.
export function applyAppManifest(basename, portalName) {
    if (isCordova() || !basename) {
        return;
    }
    setHeadElement('link[rel="manifest"]', () => {
        let link = document.createElement("link");
        link.rel = "manifest";
        return link;
    }, "href", basename + "/manifest.json");
    setHeadElement('meta[name="apple-mobile-web-app-title"]', () => {
        let meta = document.createElement("meta");
        meta.name = "apple-mobile-web-app-title";
        return meta;
    }, "content", getAppShortName(portalName));
    setHeadElement('link[rel="apple-touch-icon"]', () => {
        let link = document.createElement("link");
        link.rel = "apple-touch-icon";
        return link;
    }, "href", basename + "/icon-180.png");
}
